import {css} from '@yandex-delivery/blocks/theme/css'
import {spacing} from '@yandex-delivery/blocks/theme/theme'

export const verticalWrapper = css`
  position: relative;
  block-size: ${spacing(16.75)};
`

export const vercticalContent = css`
  & > *:not(:last-child) {
    margin-inline-end: ${spacing(1)};
  }
`
export const vertical = css`
  inline-size: ${spacing(16.25)};
  block-size: ${spacing(16.75)};
`
